import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=d82dde8a"
import script from "../services/Dashboard.js?vue&type=script&lang=js&external"
export * from "../services/Dashboard.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports